export const ids = {
  medcentersTabs: 'tabs-medcenters',
  timeslotsWrapper: 'timeslots-wrapper',
  daysListTitle: 'days-list-title',
  timeslotsListTitle: 'timeslots-list-title',
  daysContainer: 'days-container',
  slotsContainer: 'slots-container',
};

export const doctorAliases = {
  /**
   * Используется для:
   * - Рендеринг списка таймслотов.
   * - Клик по таймслоту и открытие модалки с правильной датой.
   */
  base: '1224125-mazhenov-aybek-kuatovich',
};
